<script>
import Drawer from './components/Drawer.svelte';
import Alerts from './components/Alerts.svelte';
</script>

<style>
/* The actual timeline (the vertical ruler) */
.timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

/* The actual timeline (the vertical ruler) */
.timeline::after {
  content: '';
  position: absolute;
  width: 1px;
  background-color: #31b9a3;
  top: 0;
  bottom: 0;
  left: 50%;
}

.event {
  position: relative;
  background-color: inherit;
  width: 50%;
}

/* The circles on the timeline */
.event::after {
  content: '';
  position: absolute;
  width: 2px;
  height: 2px;
  right: -6px;
  background-color: white;
  border: 4px solid #000;
  top: 50px;
  border-radius: 50%;
  z-index: 1;
}

.left {
  left: 0;
}

.right {
  left: 50%;
}

.right::after {
  left: -5px;
}

.content {
  padding: 20px 30px;
  position: relative;
}

@media screen and (max-width: 600px) {
  .timeline {
    margin-top: 100px;
    margin-right: 10px;
    margin-left: 10px;
  }
  .timeline::after {
    left: 31px;
    background-color: transparent;
  }

  .event {
    width: 100%;
    padding: 0;
  }

  .left::after, .right::after {
    left: 15px;
  }

  .right {
    left: 0%;
  }
}
</style>

<Drawer />
<Alerts />

<div class="timeline">
  <div class="event left">
    <div class="content">
      <h2>2017</h2>
      <p>Fred got annoyed at the inacurate readings from Claudine's thermometer. They then joined as a team (aptly named <em>Team Petit Poulet</em>) with
      the purpose to release as many useless IoC (Internet of Chalet) projects as possible.</p>
    </div>
  </div>
  <div class="event right">
    <div class="content">
      <h2>2018</h2>
      <p>The balcony's camera module was added, and a fierce competition took place in order to determine who could make the best script to turn an entire day's worth of images into a GIF. 
      Fred won through cheating by deactivating Claudine's CRON jobs.</p>
    </div>
  </div>
  <div class="event left">
    <div class="content">
      <h2>2019</h2>
      <p>Fred broke the Petit Poulet minuterie.</p>
    </div>
  </div>
  <div class="event right">
    <div class="content">
      <h2>2020</h2>
      <h3>IoT (Internet of Trees)</h3>
      <p>
      <em>Team Petit Poulet</em> needed a way to monitor the maple tree sap flow during the Spring season. 
      Claudine outfitted a bucket with a hypersonic sensor, a microcontroller, a battery and a LoRa (long distance radio) transciever -- the conjunction of which enables measuring the maple water level and then sending the data over radio frequencies. 
      In the chalet, the data is received by another microcontroller, also outfitted with a LoRa transciever and connected to the WiFi, that processes and stores the data (locally and remotely on the Cloud). 
      To display the data in pretty graphs, the Balcon website retrieve the data from the Balcon api, which is connected to the Cloud database.
      </p>
      <p>Because of COVID19, the 2020 maple syrup season was canceled...</p>
    </div>
  </div>
</div>
